// extracted by mini-css-extract-plugin
export default {"background":"zE","weightImage":"AE","drinkImage":"BE","content":"CE","rtbLeft":"EE","rtbRight":"FE","rtbLeftMobile":"GE","imageContainer":"HE","rtbBox":"IE","line":"JE","rtbDesktop":"KE"};
    if(module.hot) {
      // 1713996747431
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  